import React, { useState, useEffect } from "react";
import { Row, Col, FormGroup, Label, Input, Button } from "reactstrap";
import ContentLayout from "../../components/ContentLayout";
import { FaArrowLeft } from "react-icons/fa";
import { connect } from "react-redux";
import Axios from "axios";
import "./bulkPayment.scss";
import SummaryCard from "../../components/SummaryCard";
import EmptyRecordMessage from "../../components/EmptyRecordMessage/EmptyRecordMessage";
import { walletServices } from "../../_services/wallet.service";
import TableFormat from "./bulkPaymentTable";
import { alertActions } from "../../_actions";
import { appConstants } from "../../_constants";
import { appHelpers } from "../../_helpers";
let source;



const BulkPayment = (props) => {
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalClients, setTotalClients] = useState(0);  // New state for total clients
  const [totalBalance, setTotalBalance] = useState(0); 


  const getWallet = (pageNumber = 1) => {
    const { dispatch } = props;

    let payload = {
      pageSize: pageSize,
      from: pageNumber,
      parameter: {},
    };

    dispatch(alertActions.startRequest());

    walletServices.fetchWallet(payload).then((res) => {
      dispatch(alertActions.stopRequest());
      let response = res.response;

      if (res.status === appConstants.SUCCESS_RESPONSE) {
        setTableData(response.data || []);
        setTotalCount(response.walletStats.totalClients || 0);
        setCurrentPage(pageNumber === 0 ? 1 : pageNumber);
        setTotalClients(response.walletStats.totalClients || 0);  // Update totalClients
        setTotalBalance(response.walletStats.totalBalance || 0); 
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
      }
    });
  };

  // Fetch data on component mount
  useEffect(() => {
    getWallet();
  }, []); 

  return (
    <ContentLayout
      requesting={props.requesting}
      pageTitle="Bulk Payment"
    >
      <Row>
        <Col md={6}>
          <SummaryCard
            cardTitle={"Total clients"}
            bgColor={"#def5fd"}
            topValue={totalClients}
            bottomValue={"Count"}
          />
        </Col>
        <Col md={6}>
          <SummaryCard
            cardTitle={"Total balance"}
            bgColor={"#e3f8ef"}
            topValue={`₦${appHelpers.numberWithCommasOnly(totalBalance)}`}
            bottomValue={"Amount"}
          />
        </Col>
      </Row>
      <br />
      <br />
      {tableData.length === 0 && (
        <EmptyRecordMessage message={"No record match your search"} />
      )}
       {tableData.length > 0 && (
          <Row>
            <Col md={"12"}>
              <TableFormat
                currentPage={currentPage}
                fetchMore={getWallet}
                pageSize={pageSize}
                totalCount={totalCount}
                apiData={tableData}
              />
            </Col>
          </Row>
        )}
    </ContentLayout>
  );
};

const mapStateToProps = (state) => {
  const { modal, alert, progress, user, requesting } = state;
  return {
    modal,
    alert,
    progress,
    user,
    requesting,
  };
};

export default connect(mapStateToProps)(BulkPayment);
